import { SVGProps } from 'react'

export const CameraLoadCirculeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66699 6.98098C1.66699 6.68905 1.66699 6.54308 1.67917 6.42014C1.79666 5.23435 2.73472 4.29629 3.9205 4.17881C4.04345 4.16663 4.19729 4.16663 4.50498 4.16663C4.62354 4.16663 4.68282 4.16663 4.73315 4.16358C5.37583 4.12465 5.93862 3.71902 6.17878 3.12162C6.19759 3.07484 6.21517 3.0221 6.25033 2.91663C6.28548 2.81115 6.30306 2.75841 6.32187 2.71163C6.56203 2.11423 7.12482 1.7086 7.7675 1.66967C7.81784 1.66663 7.87343 1.66663 7.98461 1.66663H12.016C12.1272 1.66663 12.1828 1.66663 12.2331 1.66967C12.8758 1.7086 13.4386 2.11423 13.6788 2.71163C13.6976 2.75841 13.7152 2.81115 13.7503 2.91663C13.7855 3.0221 13.8031 3.07484 13.8219 3.12162C14.062 3.71902 14.6248 4.12465 15.2675 4.16358C15.3178 4.16663 15.3771 4.16663 15.4957 4.16663C15.8034 4.16663 15.9572 4.16663 16.0802 4.17881C17.2659 4.29629 18.204 5.23435 18.3215 6.42014C18.3337 6.54308 18.3337 6.68905 18.3337 6.98098V13.5C18.3337 14.9001 18.3337 15.6002 18.0612 16.1349C17.8215 16.6053 17.439 16.9878 16.9686 17.2275C16.4339 17.5 15.7338 17.5 14.3337 17.5H5.66699C4.26686 17.5 3.5668 17.5 3.03202 17.2275C2.56161 16.9878 2.17916 16.6053 1.93948 16.1349C1.66699 15.6002 1.66699 14.9001 1.66699 13.5V6.98098Z"
      stroke="#475467"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.0003 13.75C11.8413 13.75 13.3337 12.2576 13.3337 10.4166C13.3337 8.57568 11.8413 7.08329 10.0003 7.08329C8.15938 7.08329 6.66699 8.57568 6.66699 10.4166C6.66699 12.2576 8.15938 13.75 10.0003 13.75Z"
      stroke="#475467"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
